module.exports = __webpack_public_path__ + "img/62.6dcb98e6.png";